var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon06Review(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77778 5C5.5715 5 5.37367 5.08194 5.22781 5.22781C5.08194 5.37367 5 5.5715 5 5.77778V17.5858L6.84845 15.7373C7.03598 15.5498 7.29034 15.4444 7.55556 15.4444H18.2222C18.4285 15.4444 18.6263 15.3625 18.7722 15.2166C18.9181 15.0708 19 14.8729 19 14.6667V5.77778C19 5.5715 18.9181 5.37367 18.7722 5.22781C18.6263 5.08194 18.4285 5 18.2222 5H5.77778ZM3.81359 3.81359C4.33453 3.29266 5.04107 3 5.77778 3H18.2222C18.9589 3 19.6655 3.29266 20.1864 3.81359C20.7073 4.33453 21 5.04106 21 5.77778V14.6667C21 15.4034 20.7073 16.1099 20.1864 16.6309C19.6655 17.1518 18.9589 17.4444 18.2222 17.4444H7.96977L4.70711 20.7071C4.42111 20.9931 3.99099 21.0787 3.61732 20.9239C3.24364 20.7691 3 20.4045 3 20V5.77778C3 5.04107 3.29266 4.33453 3.81359 3.81359Z",
    fill: "#46B476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06Review);
export default __webpack_public_path__ + "static/media/icon06_review.c4cb08abd865de6860793096b7c16ee3.svg";
export { ForwardRef as ReactComponent };